import { CertificationPaymentComponent } from './certificationPayment.component';
import { TableComponentModule } from '../../main-view/table.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';


import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';

import { TranslateModule } from '@ngx-translate/core';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { UserModule } from '../../user/user/user.module';
import { DossierHeaderModule } from '../../dossiers/components/dossierHeader.module';
import { ButtonModule } from 'primeng-lts/button';
import { CalendarModule } from 'primeng-lts/calendar';
import { DropdownModule } from 'primeng-lts/dropdown';
import { MenuModule } from 'primeng-lts/menu';
import { PanelModule } from 'primeng-lts/panel';
import { TooltipModule } from 'primeng-lts/tooltip';
import { TableModule } from 'primeng-lts/table';
import { PaginatorModule } from 'primeng-lts/paginator';

@NgModule({
  declarations: [CertificationPaymentComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    CalendarModule,
    TableModule,
    PaginatorModule,
    TooltipModule,
    FormPlycaModule,
    PanelModule,
    MenuModule,
    UserModule,
    ButtonModule,
    DropdownModule,
    TranslateModule,
    WaitLoadingModule, DossierHeaderModule
  ]
})
export class CertificationPaymentModule { }
